import React from "react";
import ReactDOM from "react-dom";
import "selectize";
import "bootstrap/js/tooltip";
import StarRating from "../../components/star-rating";
import {
    initContact,
    initModalClose
} from "../../components/contact-teacher-form";
import { initSwiper } from "../../components/summaries-swiper";

const actionNodeMore = document.querySelector(".teacher-profile__more-reviews");
const actionNodeLess = document.querySelector(".teacher-profile__less-reviews");

function initStars() {
    let nodes = Array.from(document.querySelectorAll(".star-rating__stars"));

    if (nodes && nodes.length) {
        nodes.map(node => {
            ReactDOM.render(
                <StarRating isStatic={true} {...node.dataset} />,
                node
            );
        });
    }
}

function initShow() {
    if (actionNodeMore) {
        actionNodeMore.addEventListener("click", showMoreReviews.bind(this));
    }
    if (actionNodeLess) {
        actionNodeLess.addEventListener("click", showLessReviews.bind(this));
    }
}

function showMoreReviews() {
    const hiddenReviewNodes = document.querySelectorAll(
        ".teacher-profile__review-row.hidden"
    );

    if (hiddenReviewNodes.length === 0) return;

    Array.from(hiddenReviewNodes).forEach(node =>
        node.classList.remove("hidden")
    );

    actionNodeMore.classList.add("hidden");
    actionNodeLess.classList.remove("hidden");
}

function showLessReviews() {
    const toHideReviewNodes = document.querySelectorAll(
        ".teacher-profile__review-row--extra"
    );

    if (toHideReviewNodes.length === 0) return;

    Array.from(toHideReviewNodes).forEach(node => {
        node.classList.add("hidden");
    });

    actionNodeLess.classList.add("hidden");
    actionNodeMore.classList.remove("hidden");
}

function initContactButtons() {
    let contact_form = $("#contact-modal");
    initContact(contact_form);
    if (contact_form.find(".errorlist").length) {
        contact_form.toggleClass("hidden");
    }
}

(function init() {
    $("#id_courses").selectize();
    $("#id_education_level").selectize();
    initStars();
    initShow();
    initContactButtons();
    initModalClose();
    initSwiper();
    // Bootstrap tooltip
    if ($(".teacher-profile__info--screened").length) {
        $("#verified_text").tooltip({ placement: "bottom" });
    }
})();
